export default __webpack_public_path__ + "static/media/Arrow-Right.7823ec04.svg";